import * as React from "react";
import { Link } from "react-router-dom";

import { boardUrl } from "../urls";
import { Button, Divider, Header, Icon, Popup, Segment } from "../semantic-ui";
import GameDescription from "../board/GameDescription";
import { default as GameState, Color } from "../board/GameState";
import PlayerInfo from "./PlayerInfo";

type Props = {
  game: any;
  gameState: GameState;
  viewerColor: Color | undefined;
  soundEnabled: boolean;
  onResign?: () => unknown;
  onEnableSound: (enable: boolean) => unknown;
};

const GameInfo = ({
  game,
  gameState,
  viewerColor,
  soundEnabled,
  onResign,
  onEnableSound,
}: Props) => (
  <Segment>
    <Header as="h4" textAlign="center">
      <Icon name="info" /> Game Details
    </Header>
    <PlayerInfo game={game} gameState={gameState} />
    <Header size="small">
      {new GameDescription(gameState, game.nextAction, viewerColor).toString()}
    </Header>
    <Divider horizontal>
      <Header as="h4" textAlign="center">
        <Icon name="wrench" /> Actions
      </Header>
    </Divider>
    <Button as={Link} to={boardUrl(game.epd)} icon>
      <Icon name="edit" /> Open in editor
    </Button>
    {game.winner ? null : (
      <Popup
        trigger={
          <Button icon>
            <Icon name="close" /> Resign from game
          </Button>
        }
        on="focus"
      >
        <Button color="red" onClick={onResign}>
          Confirm resignation
        </Button>
      </Popup>
    )}
    <Button
      icon
      secondary={!soundEnabled}
      title="Toggle sounds"
      onClick={() => onEnableSound(!soundEnabled)}
    >
      <Icon name="volume off" />
    </Button>
  </Segment>
);

export default GameInfo;
